import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";

const DeleteModal = ({ isOpen, toggle, title, message, onConfirm, loading = false }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size="sm" contentClassName="border-0 shadow-lg rounded-4 overflow-hidden">
            <ModalBody className="text-center p-4">
                <div className="mx-auto mb-3 d-flex align-items-center justify-content-center bg-danger bg-opacity-10 text-danger rounded-circle" style={{ width: "64px", height: "64px" }}>
                    <i className="bi bi-trash3-fill fs-2"></i>
                </div>
                <h5 className="fw-bold text-dark mb-2">{title || "Confirm Delete"}</h5>
                <p className="text-muted small mb-4">{message || "Are you sure you want to delete this item? This action cannot be undone."}</p>
                <div className="d-flex gap-2 justify-content-center">
                    <Button color="light" className="rounded-pill px-4 fw-bold border flex-grow-1" onClick={toggle} disabled={loading}>
                        Cancel
                    </Button>
                    <Button color="danger" className="rounded-pill px-4 fw-bold shadow-sm flex-grow-1" onClick={onConfirm} disabled={loading}>
                        {loading ? "Deleting..." : "Delete"}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default DeleteModal;
